import { $ } from "@/common/Axios";

export default {
  /**
   * 线索对接链路配置
   */
  remarkCode: {
    /*
     * 添加编辑
     * remarkCode  ( query required)
     */
    put: (p, c) => $.put("/api/ums/promote/remarkCode", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/remarkCode", p, c),
  },
  remarkCode_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/remarkCode/list", p, c),
  },
  remarkCode_listSimple: {
    /*
     * 简易列表
     * parentId 上级ID (integer query )
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) => $.get("/api/ums/promote/remarkCode/listSimple", p, c),
  },
  remarkCode_listSimpleNameCode: {
    /*
     * 简易列表，返回name code
     * parentId 上级ID (integer query )
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/remarkCode/listSimpleNameCode", p, c),
  },
  remarkCode_listByCodes: {
    /*
     * 根据code列表查询名字列表
     * codes code列表 (array query )
     */
    get: (p, c) => $.get("/api/ums/promote/remarkCode/listByCodes", p, c),
  },

  /**
   * 高分资源
   */
  highScoreResource_update: {
    /*
     * 编辑导出状态和备注
     * updateBO 编辑内容 ( query required)
     */
    put: (p, c) => $.put("/api/ums/promote/highScoreResource/update", p, c),
  },
  highScoreResource_upload: {
    /*
     * 导入批量修改导出状态和备注
     * excelFile Excel文件 (string body required)
     */
    post: (p, c) => $.post("/api/ums/promote/highScoreResource/upload", p, c),
  },
  highScoreResource_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/highScoreResource/list", p, c),
  },
  highScoreResource_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ums/promote/highScoreResource/export", p, c),
  },

  /**
   * 手动分配池管理
   */
  handleCluePool_able: {
    /*
     * 批量启用禁用
     * ids id列表 (array query required)
     * ableStatus 启用状态 (string query required)
     */
    put: (p, c) => $.put("/api/ums/promote/handleCluePool/able", p, c),
  },
  handleCluePool: {
    /*
     * 添加
     * pool  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/handleCluePool", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/handleCluePool", p, c),
  },
  handleCluePool_listSimpleGroup: {
    /*
     * 组简易列表
     * type 类型 (string query required)
     * groupType 组类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/handleCluePool/listSimpleGroup", p, c),
  },
  handleCluePool_listMember: {
    /*
     * 成员列表
     * groupId 组id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/handleCluePool/listMember", p, c),
  },
  handleCluePool_listGroup: {
    /*
     * 组列表（分页）
     */
    get: (p, c) => $.get("/api/ums/promote/handleCluePool/listGroup", p, c),
  },

  /**
   * 全日制资源
   */
  fullTimeResource_drawFromGlobal: {
    /*
     * 全局资源领取
     * clueId 线索id (integer query required)
     * contactWay 联系方式 (string query required)
     * clueStatus 线索状态 (string query required)
     * preContactTime 上次联系时间 (string query )
     * remark 备注 (string query )
     * contactRecord 附件 (string query )
     * contactDuration 联系时长 (integer query )
     * intentionGrade 意向等级 (string query )
     * intentionType 意向类型 (string query )
     * invalidReason 无效原因 (string query )
     */
    put: (p, c) =>
      $.put("/api/ums/promote/fullTimeResource/drawFromGlobal", p, c),
  },
  fullTimeResource_drawFromDepartment: {
    /*
     * 部门资源领取
     * clueId 线索id (integer query required)
     * contactWay 联系方式 (string query required)
     * clueStatus 线索状态 (string query required)
     * preContactTime 上次联系时间 (string query )
     * remark 备注 (string query )
     * contactRecord 附件 (string query )
     * contactDuration 联系时长 (integer query )
     * intentionGrade 意向等级 (string query )
     * intentionType 意向类型 (string query )
     * invalidReason 无效原因 (string query )
     */
    put: (p, c) =>
      $.put("/api/ums/promote/fullTimeResource/drawFromDepartment", p, c),
  },
  fullTimeResource_assignFromDepartment: {
    /*
     * 分配部门资源（院校总监/院校经理，无保护限制）
     * clueId 线索id (integer query required)
     * adminId 管理员id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/promote/fullTimeResource/assignFromDepartment", p, c),
  },
  fullTimeResource_listPersonal: {
    /*
     * 个人资源列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/fullTimeResource/listPersonal", p, c),
  },
  fullTimeResource_listGlobal: {
    /*
     * 全局资源列表
     */
    get: (p, c) => $.get("/api/ums/promote/fullTimeResource/listGlobal", p, c),
  },
  fullTimeResource_listDepartment: {
    /*
     * 部门资源列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/fullTimeResource/listDepartment", p, c),
  },

  /**
   * 来源网址
   */
  clueChannelAddress_setNotifyAdminId: {
    /*
     * 设置异常通知接收人
     * adminId 管理员id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/promote/clueChannelAddress/setNotifyAdminId", p, c),
  },
  clueChannelAddress: {
    /*
     * 添加
     * clueOrigin  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/clueChannelAddress", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/clueChannelAddress", p, c),
  },
  clueChannelAddress_upload: {
    /*
     * 导入
     * channelType 渠道类型：网络营销、新媒体推广、AI营销 (string query required)
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ums/promote/clueChannelAddress/upload", p, c),
  },
  clueChannelAddress_listType: {
    /*
     * 业务类型列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueChannelAddress/listType", p, c),
  },
  clueChannelAddress_listSimple: {
    /*
     * 简易列表
     * channelType 渠道类型：网络营销、新媒体推广、AI营销 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/listSimple", p, c),
  },
  clueChannelAddress_listPromotionChannels: {
    /*
     * 推广渠道列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/listPromotionChannels", p, c),
  },
  clueChannelAddress_listOriginSchool: {
    /*
     * 来源学校列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/listOriginSchool", p, c),
  },
  clueChannelAddress_listOriginSchoolByType: {
    /*
     * 来源学校列表
     * type 业务类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/listOriginSchoolByType", p, c),
  },
  clueChannelAddress_listFullPromotionChannel: {
    /*
     * 推广渠道列表, 添加时候用
     * type 业务类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/ums/promote/clueChannelAddress/listFullPromotionChannel",
        p,
        c
      ),
  },
  clueChannelAddress_listForXmt: {
    /*
     * 列表（新媒体推广）
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/listForXmt", p, c),
  },
  clueChannelAddress_listForNet: {
    /*
     * 列表（网络营销）
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/listForNet", p, c),
  },
  clueChannelAddress_listForAi: {
    /*
     * 列表（AI营销）
     */
    get: (p, c) => $.get("/api/ums/promote/clueChannelAddress/listForAi", p, c),
  },
  clueChannelAddress_listChannelAddress: {
    /*
     * 来源网址列表
     * promotionChannels 推广渠道 (string query )
     * type 业务类型 (string query )
     * channelType 渠道类型：网络营销、新媒体推广、AI营销 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/listChannelAddress", p, c),
  },
  clueChannelAddress_getNotifyAdminId: {
    /*
     * 获取异常通知接收人
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/getNotifyAdminId", p, c),
  },
  clueChannelAddress_getByAddress: {
    /*
     * 通过网址查询
     * channelAddress 来源网址 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/getByAddress", p, c),
  },
  clueChannelAddress_exportForXmt: {
    /*
     * 导出（新媒体贵广）
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/exportForXmt", p, c),
  },
  clueChannelAddress_exportForNet: {
    /*
     * 导出（网络营销）
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/exportForNet", p, c),
  },
  clueChannelAddress_exportForAi: {
    /*
     * 导出（AI营销）
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueChannelAddress/exportForAi", p, c),
  },

  /**
   * 网络线索
   */
  clue_saveContact: {
    /*
     * 添加联系,添加前先调用获取最后未创建联系接口,如果存在则不调用次此接口,先让管理员编辑未创建联系
     * id 线索id (integer query required)
     * contactWay 联系方式(下拉)：电话，微信，电子邮件,qq,上门，其他 (string query )
     * status 线索状态：1待分配6无效资源 (string query required)
     * preContactTime 预计下次联系时间 (string query required)
     * remark 备注 (string query )
     * contactRecord 附件，可以上传音频，可以上传图片 (string query )
     * contactDuration 如果上传音频，时长 (integer query )
     */
    put: (p, c) => $.put("/api/ums/promote/clue/saveContact", p, c),
  },
  clue_leaderUpdate: {
    /*
     * 主管编辑
     * id 线索 id (integer query required)
     * originDetail 具体来源(来源渠道为运营营销) (string query )
     * consultWay 咨询方式 (string query required)
     * keyword 关键字 (string query )
     * channelAddressSimple 来源网址 (string query required)
     */
    put: (p, c) => $.put("/api/ums/promote/clue/leaderUpdate", p, c),
  },
  clue_drawUnsigned: {
    /*
     * 休息时间领取资源
     * id 资源id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/clue/drawUnsigned", p, c),
  },
  clue_customerServiceReassign: {
    /*
     * 客服二次分配线索（不受15天内客服创建/领取限制，需最近一次分配销售超1天未联系）
     * id 线索id (integer query required)
     * adminId 目标销售管理员id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/clue/customerServiceReassign", p, c),
  },
  clue_customerServiceDraw: {
    /*
     * 客服领取线索（保存来源网址信息）
     * id 线索id (integer query required)
     * channelAddress 来源网址 (string query required)
     */
    put: (p, c) => $.put("/api/ums/promote/clue/customerServiceDraw", p, c),
  },
  clue_assign: {
    /*
     * 分配线索
     * ids 线索 id (array query required)
     * adminId 管理员id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/clue/assign", p, c),
  },
  clue: {
    /*
     * 添加线索
     * c  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/clue", p, c),
  },
  clue_createByCode_upload: {
    /*
     * 批量导入线索
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ums/promote/clue/createByCode/upload", p, c),
  },
  clue_createByCode_uploadPresenter: {
    /*
     * 批量导入宣讲人
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/uploadPresenter", p, c),
  },
  clue_createByCode_uploadPersonConfig: {
    /*
     * 导入驻点信息
     * batch 退伍批次 (string query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/uploadPersonConfig", p, c),
  },
  clue_createByCode_uploadForAssign: {
    /*
     * 批量导入分配线索
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/uploadForAssign", p, c),
  },
  clue_createByCode_uploadDegreeConfig: {
    /*
     * 导入学历配置
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/uploadDegreeConfig", p, c),
  },
  clue_createByCode_updateByBack: {
    /*
     * 通过线索二维码填写创建线索
     * code  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/updateByBack", p, c),
  },
  clue_createByCode_syncDegreeInfo: {
    /*
     * 同步学历信息
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/syncDegreeInfo", p, c),
  },
  clue_createByCode_setTimeConfig: {
    /*
     * 配置驻点时间
     * timeConfig  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/setTimeConfig", p, c),
  },
  clue_createByCode_setPersonConfig: {
    /*
     * 设置驻点信息配置
     * batch 退伍批次 (string query required)
     * personConfig  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/setPersonConfig", p, c),
  },
  clue_createByCode_setDegreeConfig: {
    /*
     * 设置学历配置
     * degreeConfig  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/setDegreeConfig", p, c),
  },
  clue_createByCode_save: {
    /*
     * 通过线索二维码填写创建线索
     * code  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/clue/createByCode/save", p, c),
  },
  clue_createByCode_saveByBack: {
    /*
     * 通过线索二维码填写创建线索
     * code  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/saveByBack", p, c),
  },
  clue_createByCode_draw: {
    /*
     * 领取
     * id 线索 id (integer query required)
     */
    post: (p, c) => $.post("/api/ums/promote/clue/createByCode/draw", p, c),
  },
  clue_createByCode_assignCovert: {
    /*
     * 分配转化人
     * ids 行 ids (array query required)
     * newAdminId 新转化人 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clue/createByCode/assignCovert", p, c),
  },
  clue_searchByPhone: {
    /*
     * 查重
     * phone 手机号(三选一) (string query )
     * wechat 微信 (string query )
     * qq qq (string query )
     */
    get: (p, c) => $.get("/api/ums/promote/clue/searchByPhone", p, c),
  },
  clue_list: {
    /*
     * 线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/list", p, c),
  },
  clue_listUnsigned: {
    /*
     * 获取未分配的线索
     */
    get: (p, c) => $.get("/api/ums/promote/clue/listUnsigned", p, c),
  },
  clue_listSimplePromotion: {
    /*
     * 线索推广渠道下拉列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/listSimplePromotion", p, c),
  },
  clue_listSelfNewMediaPromoteClue: {
    /*
     * 自考新媒体推广线索列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/listSelfNewMediaPromoteClue", p, c),
  },
  clue_listForCreator: {
    /*
     * 创建人线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/listForCreator", p, c),
  },
  clue_listForAdultPromotion: {
    /*
     * 成人学历推广线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/listForAdultPromotion", p, c),
  },
  clue_listContact: {
    /*
     * 线索联系记录
     * id 线索id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/clue/listContact", p, c),
  },
  clue_listCluePromotionInfo: {
    /*
     * 线索推广渠道配置列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/listCluePromotionInfo", p, c),
  },
  clue_list_xmt: {
    /*
     * 新媒体线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/list/xmt", p, c),
  },
  clue_list_ai: {
    /*
     * AI营销线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/list/ai", p, c),
  },
  clue_getSelfNewMediaPromoteClueInfo: {
    /*
     * 自考新媒体推广线索情况
     * type 时间类型 (string query )
     * start 时间类型 (string query )
     * end 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/getSelfNewMediaPromoteClueInfo", p, c),
  },
  clue_getContactRecordRemark: {
    /*
     * 获取聊天记录备注
     * id 线索id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/clue/getContactRecordRemark", p, c),
  },
  clue_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ums/promote/clue/export", p, c),
  },
  clue_exportForAdultPromotion: {
    /*
     * 成教推广线索导出
     */
    get: (p, c) => $.get("/api/ums/promote/clue/exportForAdultPromotion", p, c),
  },
  clue_export_xmt: {
    /*
     * 新媒体线索导出
     */
    get: (p, c) => $.get("/api/ums/promote/clue/export/xmt", p, c),
  },
  clue_export_ai: {
    /*
     * AI营销线索导出
     */
    get: (p, c) => $.get("/api/ums/promote/clue/export/ai", p, c),
  },
  clue_details: {
    /*
     * 详情,只有可编辑的才有详情按钮
     * id 线索id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/clue/details", p, c),
  },
  clue_createByCode_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/createByCode/list", p, c),
  },
  clue_createByCode_listBatch: {
    /*
     * 退伍批次列表
     */
    get: (p, c) => $.get("/api/ums/promote/clue/createByCode/listBatch", p, c),
  },
  clue_createByCode_getTimeConfig: {
    /*
     * 查看驻点时间
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/getTimeConfig", p, c),
  },
  clue_createByCode_getPersonConfig: {
    /*
     * 获取驻点信息配置
     * batch 退伍批次 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/getPersonConfig", p, c),
  },
  clue_createByCode_getDegreeConfig: {
    /*
     * 获取学历配置
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/getDegreeConfig", p, c),
  },
  clue_createByCode_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ums/promote/clue/createByCode/export", p, c),
  },
  clue_createByCode_exportPersonConfig: {
    /*
     * 导出驻点信息
     * batch 退伍批次 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/exportPersonConfig", p, c),
  },
  clue_createByCode_exportDegreeConfig: {
    /*
     * 导出学历配置
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/exportDegreeConfig", p, c),
  },
  clue_createByCode_downloadMould: {
    /*
     * 下载批量导入线索模板
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/downloadMould", p, c),
  },
  clue_createByCode_downloadMouldPresenter: {
    /*
     * 下载批量导入宣讲人模板
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/downloadMouldPresenter", p, c),
  },
  clue_createByCode_downloadMouldForAssign: {
    /*
     * 下载批量导入分配线索模板
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clue/createByCode/downloadMouldForAssign", p, c),
  },

  /**
   * 后台留言
   */
  backgroundMessage_sign: {
    /*
     * 标记
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/backgroundMessage/sign", p, c),
  },
  backgroundMessage_messageForClient: {
    /*
     * c端留言
     * code 公众号code，不用用户确认，用户关注后获取 (string query )
     * name 名字 (string query )
     * phone 手机号 (string query required)
     * age 年龄 (string query )
     * currentLevel 当前学历 (string query )
     * wantLevel 报名学历 (string query )
     * channel 渠道，不填则为网络营销，官网留言填运营营销，其他如成考宝典等 (string query )
     * address 地址，包含参数 (string query )
     */
    post: (p, c) =>
      $.post("/api/ums/promote/backgroundMessage/messageForClient", p, c),
  },
  backgroundMessage_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/backgroundMessage/list", p, c),
  },

  /**
   * 自动线索排班
   */
  autoCluePool_able: {
    /*
     * 启用|禁用
     * ids id (array query required)
     * ableStatus 启用禁用 (string query required)
     */
    put: (p, c) => $.put("/api/ums/promote/autoCluePool/able", p, c),
  },
  autoCluePool: {
    /*
     * 添加
     * pool  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/autoCluePool", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/autoCluePool", p, c),
  },
  autoCluePool_uploadSubMember: {
    /*
     * 导入子列表（人员）
     * parentId 父id (integer query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ums/promote/autoCluePool/uploadSubMember", p, c),
  },
  autoCluePool_copy: {
    /*
     * 复制
     * sourceId 源分配池id (integer query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     */
    post: (p, c) => $.post("/api/ums/promote/autoCluePool/copy", p, c),
  },
  autoCluePool_listSubMember: {
    /*
     * 子列表（人员）
     * parentId 父id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/autoCluePool/listSubMember", p, c),
  },
  autoCluePool_listSubForAncestor: {
    /*
     * 最高级别子列表
     * parentId 父id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ums/promote/autoCluePool/listSubForAncestor", p, c),
  },
  autoCluePool_listPool: {
    /*
     * 分配池列表
     */
    get: (p, c) => $.get("/api/ums/promote/autoCluePool/listPool", p, c),
  },
  autoCluePool_listAncestor: {
    /*
     * 最高级别列表
     */
    get: (p, c) => $.get("/api/ums/promote/autoCluePool/listAncestor", p, c),
  },
  autoCluePool_listAncestorSimple: {
    /*
     * 最高级别列表（简单）
     */
    get: (p, c) =>
      $.get("/api/ums/promote/autoCluePool/listAncestorSimple", p, c),
  },
  autoCluePool_exportSubMember: {
    /*
     * 导出子列表（人员）
     * parentId 父id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/autoCluePool/exportSubMember", p, c),
  },

  /**
   * 预约到访
   */
  appointment_update: {
    /*
     * 编辑
     * id id (integer query required)
     * receptionistId 接待人id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/appointment/update", p, c),
  },
  appointment_updateAwardFinishStatus: {
    /*
     * 批量更新奖励发放状态
     * ids ids (array query required)
     * awardFinishStatus 奖励是否已发放：是否 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ums/promote/appointment/updateAwardFinishStatus", p, c),
  },
  appointment_reception: {
    /*
     * 接待
     * id id (integer query required)
     * receptionContent 接待人情况 (string query required)
     * receptionTime 接待人时间 (string query required)
     */
    put: (p, c) => $.put("/api/ums/promote/appointment/reception", p, c),
  },
  appointment_change: {
    /*
     * 变更接待人-申请
     * id 原接待记录id (integer query required)
     * receptionistId 新接待人id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/appointment/change", p, c),
  },
  appointment_apply: {
    /*
     * 申请
     * schoolRollId 合同编号 (integer query required)
     * userId userId (integer query required)
     * receptionistId 接待人id (integer query required)
     * receptionContent 接待人情况 (string query )
     * receptionTime 接待人时间 (string query )
     */
    post: (p, c) => $.post("/api/ums/promote/appointment/apply", p, c),
  },
  appointment_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/appointment/list", p, c),
  },
  appointment_listSimple: {
    /*
     * 简易列表
     * schoolRollId 合同编号 (integer query )
     * userId 用户id (integer query )
     */
    get: (p, c) => $.get("/api/ums/promote/appointment/listSimple", p, c),
  },
  appointment_listSimpleRecord: {
    /*
     * 简易变更列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/appointment/listSimpleRecord", p, c),
  },
  appointment_listForReception: {
    /*
     * 接待列表
     */
    get: (p, c) => $.get("/api/ums/promote/appointment/listForReception", p, c),
  },
  appointment_getDetail: {
    /*
     * 获取详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/appointment/getDetail", p, c),
  },
  appointment_getChangeDetail: {
    /*
     * 变更接待人-获取详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/promote/appointment/getChangeDetail", p, c),
  },
  appointment_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ums/promote/appointment/export", p, c),
  },
  appointment_exportForReception: {
    /*
     * 接待列表-导出
     */
    get: (p, c) =>
      $.get("/api/ums/promote/appointment/exportForReception", p, c),
  },
  appointment: {
    /*
     * 删除(状态为未接待可以删除)
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/appointment", p, c),
  },

  /**
   * 招生线索
   */
  admissions_clue_updateDetail: {
    /*
     * 编辑详情
     * id 线索 id (integer query required)
     * name 名字 (string query required)
     * phone 手机号 (string query )
     * wechat 微信 (string query )
     * wechatQrCode 微信二维码 (string query )
     * qq qq (string query )
     * email email (string query )
     * province 省 (string query )
     * city 市 (string query )
     * district 县(区) (string query )
     * industry 行业 (string query )
     * company 公司 (string query )
     * station 岗位 (string query )
     * telephone 座机 (string query )
     * companyAddress 公司地址 (string query )
     * goal 报读目的 (string query )
     * wantMajorLevel 意向层次 (string query )
     * wantSite 意向学校 (string query )
     * wantMajor 意向专业 (string query )
     * adminRemark 负责人备注 (string query )
     * graduateSchool 毕业院校 (string query )
     * graduateMajor 毕业专业 (string query )
     * sourceLinkRemark 毕业专业 (string query )
     * intentionType 意向产品 (string query )
     * invalidReason 无效原因 (string query )
     */
    put: (p, c) => $.put("/api/ums/promote/admissions/clue/updateDetail", p, c),
  },
  admissions_clue_saveContact: {
    /*
     * 添加联系
     * id 线索id (integer query required)
     * contactWay 联系方式(下拉)：电话，微信，电子邮件,qq,上门，其他 (string query )
     * status 本次联系线索状态：：key=添加线索状态 (string query required)
     * preContactTime 预计下次联系时间 (string query required)
     * remark 备注 (string query )
     * contactRecord 附件，可以上传音频，可以上传图片 (string query )
     * contactDuration 如果上传音频，时长 (integer query )
     * intentionGrade 意向等级 (string query )
     * intentionType 意向产品 (string query )
     * invalidReason 无效原因 (string query )
     */
    put: (p, c) => $.put("/api/ums/promote/admissions/clue/saveContact", p, c),
  },
  admissions_clue_giveUpClue: {
    /*
     * 主动流入公海
     * id 线索 id列表 (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/admissions/clue/giveUpClue", p, c),
  },
  admissions_clue_drawFromSea: {
    /*
     * 公海领取线索
     * type 线索类型 (string query )
     * channel 来源渠道 (string query )
     * detail 来源详情 (string query )
     * clueStatus 线索状态 (string query )
     * currentStatus 最新联系状态 (string query )
     * province 省份 (string query )
     * createStartTime 线索创建开始时间 (string query )
     * createEndTime 线索创建结束时间 (string query )
     * assignStartTime 最近分配开始时间 (string query )
     * assignEndTime 最近分配结束时间 (string query )
     * contactStartTime 最近联系开始时间 (string query )
     * contactEndTime 最近联系结束时间 (string query )
     * drawCount 领取数量 (integer query required)
     * sortField 排序字段 (string query )
     * sortRule 排序规则,升序降序 (string query )
     */
    put: (p, c) => $.put("/api/ums/promote/admissions/clue/drawFromSea", p, c),
  },
  admissions_clue_assign: {
    /*
     * 分配
     * ids 线索 id列表 (array query required)
     * adminId 管理员id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/admissions/clue/assign", p, c),
  },
  admissions_clue_assignWithParams: {
    /*
     * 特殊分配线索-分配
     * clueCreatorId 线索创建人 (integer query )
     * adminRemark 负责人备注 (string query )
     * receiverId 接收人ID (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/promote/admissions/clue/assignWithParams", p, c),
  },
  admissions_clue_assignToMeng: {
    /*
     * 分配线索给张萌
     * ids 线索 id (array query required)
     */
    put: (p, c) => $.put("/api/ums/promote/admissions/clue/assignToMeng", p, c),
  },
  admissions_clue_assignForSea: {
    /*
     * 批量分配-推广平台-全日制公海
     * ids 线索 id列表 (array query required)
     * adminId 管理员id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/promote/admissions/clue/assignForSea", p, c),
  },
  admissions_clue_assignForDepartment: {
    /*
     * 分配-部门线索
     * ids 线索 id列表 (array query required)
     * adminId 管理员id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/promote/admissions/clue/assignForDepartment", p, c),
  },
  admissions_clue_upload: {
    /*
     * 批量上传
     * parentDraw 是否领取下级线索 (string query required)
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ums/promote/admissions/clue/upload", p, c),
  },
  admissions_clue_save: {
    /*
     * 添加线索
     * name 名字 (string query required)
     * type 业务类型 成人教育 全日制 落户 (string query required)
     * channel 来源渠道 (string query required)
     * detail 来源详情 (string query required)
     * phone 手机号 (string query )
     * wechat 微信 (string query )
     * qq qq (string query )
     * wechatQrCode 微信二维码 (string query )
     * contactWay 联系方式(下拉)：电话，微信，电子邮件,qq,上门，其他 (string query )
     * status 线索状态：1待分配6无效资源 (string query )
     * preContactTime 预计下次联系时间 (string query )
     * remark 备注 (string query )
     * contactRecord 附件，可以上传音频，可以上传图片 (string query )
     * contactDuration 如果上传音频，时长 (integer query )
     * intentionGrade 意向等级, 线索状态为有意向时必填 (string query )
     * originSchool 来源学校 (string query )
     * oldSchoolRollId 老生合同编号 (integer query )
     * refererUserId 推荐人, 如果角色在配置内的必填 (integer query )
     * intentionType 意向产品 (string query )
     * invalidReason 无效原因 (string query )
     */
    post: (p, c) => $.post("/api/ums/promote/admissions/clue/save", p, c),
  },
  admissions_clue_saveByWeCom: {
    /*
     * 企微业务助手-添加线索
     * externalUserId externalUserId (string query required)
     * name 名字 (string query required)
     * type 业务类型 成人教育 全日制 落户 (string query required)
     * phone 手机号 (string query )
     * wechat 微信 (string query )
     * qq qq (string query )
     * contactWay 联系方式(下拉)：电话，微信，电子邮件,qq,上门，其他 (string query )
     * status 线索状态：1待分配6无效资源 (string query )
     * preContactTime 预计下次联系时间 (string query )
     * remark 备注 (string query )
     * contactRecord 附件，可以上传音频，可以上传图片 (string query )
     * contactDuration 如果上传音频，时长 (integer query )
     * intentionGrade 意向等级, 线索状态为有意向时必填 (string query )
     * originSchool 来源学校 (string query )
     */
    post: (p, c) =>
      $.post("/api/ums/promote/admissions/clue/saveByWeCom", p, c),
  },
  admissions_clue_saveByWeComForArmy: {
    /*
     * 中军企微业务助手-添加线索
     * externalUserId externalUserId (string query required)
     * name 名字 (string query required)
     * type 业务类型 成人教育 全日制 落户 (string query required)
     * phone 手机号 (string query )
     * wechat 微信 (string query )
     * qq qq (string query )
     * contactWay 联系方式(下拉)：电话，微信，电子邮件,qq,上门，其他 (string query )
     * status 线索状态：1待分配6无效资源 (string query )
     * preContactTime 预计下次联系时间 (string query )
     * remark 备注 (string query )
     * contactRecord 附件，可以上传音频，可以上传图片 (string query )
     * contactDuration 如果上传音频，时长 (integer query )
     * intentionGrade 意向等级, 线索状态为有意向时必填 (string query )
     * originSchool 来源学校 (string query )
     */
    post: (p, c) =>
      $.post("/api/ums/promote/admissions/clue/saveByWeComForArmy", p, c),
  },
  admissions_clue_saveByWeComForAigc: {
    /*
     * 企微业务助手-创建AIGC线索
     * externalUserId externalUserId (string query required)
     * phone 手机号(与微信至少填写一个) (string query )
     * wechat 微信(与手机号至少填写一个) (string query )
     */
    post: (p, c) =>
      $.post("/api/ums/promote/admissions/clue/saveByWeComForAigc", p, c),
  },
  admissions_clue_draw: {
    /*
     * 领取
     * id 线索 id (integer query required)
     */
    post: (p, c) => $.post("/api/ums/promote/admissions/clue/draw", p, c),
  },
  admissions_clue_bindByWeCom: {
    /*
     * 企微业务助手-绑定线索
     * externalUserId externalUserId (string query required)
     * phone 手机号 (string query )
     * wechat 微信 (string query )
     * qq qq (string query )
     */
    post: (p, c) =>
      $.post("/api/ums/promote/admissions/clue/bindByWeCom", p, c),
  },
  admissions_clue_addChildPhone: {
    /*
     * 添加关联手机号
     * id 线索 id (integer query required)
     * phone 手机号 (string query )
     * wechat 微信 (string query )
     * qq qq (string query )
     * name 名字 (string query )
     * adminRemark 负责人备注 (string query )
     */
    post: (p, c) =>
      $.post("/api/ums/promote/admissions/clue/addChildPhone", p, c),
  },
  admissions_clue_searchDrawCount: {
    /*
     * 查询公海资源当日已领取数量
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/searchDrawCount", p, c),
  },
  admissions_clue_searchClueReferralUser: {
    /*
     * 根据线索ID或身份证号查询线索推荐人
     * clueId 线索ID, 线索上报时候查询 (integer query )
     * idCardNo 身份证号, 合同代报时候查询 (string query )
     * phone 手机, 合同代报时候查询 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/searchClueReferralUser", p, c),
  },
  admissions_clue_list: {
    /*
     * 学历线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/admissions/clue/list", p, c),
  },
  admissions_clue_listFullTimeSeaForPromote: {
    /*
     * 全日制公海列表-推广平台
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/listFullTimeSeaForPromote", p, c),
  },
  admissions_clue_listForGlobal: {
    /*
     * 全局搜索线索列表
     * phone 手机号 (string query )
     * qq qq (string query )
     * wechat wechat (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/listForGlobal", p, c),
  },
  admissions_clue_listForCreate: {
    /*
     * 部门线索列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/listForCreate", p, c),
  },
  admissions_clue_listClueActivateRecord: {
    /*
     * 线索激活记录列表
     * clueId 线索id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/listClueActivateRecord", p, c),
  },
  admissions_clue_listAdultSeaForPromote: {
    /*
     * 成人教育公海列表-推广平台
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/listAdultSeaForPromote", p, c),
  },
  admissions_clue_getSeaDrawMainPage: {
    /*
     * 新公海首页
     * timeType 时间， 仅限当日或昨日 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/getSeaDrawMainPage", p, c),
  },
  admissions_clue_getClueInfoByWeCom: {
    /*
     * 企微业务助手-查询线索情况
     * externalUserId 企微externalUserId (string query required)
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/getClueInfoByWeCom", p, c),
  },
  admissions_clue_exportForCreate: {
    /*
     * 部门线索列表导出
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/exportForCreate", p, c),
  },
  admissions_clue_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/downloadMould", p, c),
  },
  admissions_clue_countAssignWithParams: {
    /*
     * 特殊分配线索-查询数量
     * clueCreatorId 线索创建人 (integer query )
     * adminRemark 负责人备注 (string query )
     */
    get: (p, c) =>
      $.get("/api/ums/promote/admissions/clue/countAssignWithParams", p, c),
  },

  /**
   * 老生推荐资源
   */
  refererClue: {
    /*
     * 添加编辑
     * id id，编辑传 (integer query )
     * phone 手机号 (string query )
     * wechat 微信 (string query )
     * remark 备注 (string query )
     * name 线索名称 (string query required)
     * oldSchoolRollId 老生合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ums/promote/refererClue", p, c),

    /*
     * 删除，只有userId为空的时候才能删除,删自己的
     * id id (integer query )
     */
    delete: (p, c) => $.delete("/api/ums/promote/refererClue", p, c),
  },
  refererClue_transferClue: {
    /*
     * 转化线索
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/ums/promote/refererClue/transferClue", p, c),
  },
  refererClue_batchAssign: {
    /*
     * 批量分配资源
     * ids id (array query required)
     * adminId 新负责人 (integer query required)
     */
    post: (p, c) => $.post("/api/ums/promote/refererClue/batchAssign", p, c),
  },
  refererClue_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/refererClue/list", p, c),
  },
  refererClue_listOldByName: {
    /*
     * 根据老生名字查询合同列表
     * name 老生名字，至少2个字，模糊查询 (string query required)
     */
    get: (p, c) => $.get("/api/ums/promote/refererClue/listOldByName", p, c),
  },

  /**
   * 推广现金消费
   */
  feeRecord: {
    /*
     * 添加
     * feeRecord  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/feeRecord", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/feeRecord", p, c),
  },
  feeRecord_upload: {
    /*
     * 导入推广现金消费
     * channelType 渠道类型：网络营销、新媒体推广 (string query required)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/ums/promote/feeRecord/upload", p, c),
  },
  feeRecord_listForXmt: {
    /*
     * 列表（新媒体）
     */
    get: (p, c) => $.get("/api/ums/promote/feeRecord/listForXmt", p, c),
  },
  feeRecord_listForNet: {
    /*
     * 列表（网络营销）
     */
    get: (p, c) => $.get("/api/ums/promote/feeRecord/listForNet", p, c),
  },
  feeRecord_exportForXmt: {
    /*
     * 导出（新媒体）
     */
    get: (p, c) => $.get("/api/ums/promote/feeRecord/exportForXmt", p, c),
  },
  feeRecord_exportForNet: {
    /*
     * 导出（网络营销）
     */
    get: (p, c) => $.get("/api/ums/promote/feeRecord/exportForNet", p, c),
  },

  /**
   * 抖音直播间
   */
  douyinLliveRoom: {
    /*
     * 添加或修改
     * liveRoom  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/douyinLliveRoom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/douyinLliveRoom", p, c),
  },
  douyinLliveRoom_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/douyinLliveRoom/list", p, c),
  },
  douyinLliveRoom_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/ums/promote/douyinLliveRoom/listSimple", p, c),
  },

  /**
   * 抖音直播间排班
   */
  douyinLliveRoomSchedule: {
    /*
     * 添加或修改
     * schedule  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/douyinLliveRoomSchedule", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ums/promote/douyinLliveRoomSchedule", p, c),
  },
  douyinLliveRoomSchedule_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/douyinLliveRoomSchedule/list", p, c),
  },

  /**
   * 抖音直播间投留费用
   */
  douyinLliveRoomCost: {
    /*
     * 添加或修改
     * cost  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/douyinLliveRoomCost", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/douyinLliveRoomCost", p, c),
  },
  douyinLliveRoomCost_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/douyinLliveRoomCost/list", p, c),
  },

  /**
   * 抖音资源线索管理
   */
  douyinClue_transfer: {
    /*
     * 转线索
     * id 抖音资源id (integer query required)
     * groupId 分配池组id (integer query required)
     */
    post: (p, c) => $.post("/api/ums/promote/douyinClue/transfer", p, c),
  },
  douyinClue_receive: {
    /*
     * 领取
     * id 抖音资源id (integer query required)
     */
    post: (p, c) => $.post("/api/ums/promote/douyinClue/receive", p, c),
  },
  douyinClue_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/douyinClue/list", p, c),
  },
  douyinClue_listGroupSimple: {
    /*
     * 分配池组简易列表
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/ums/promote/douyinClue/listGroupSimple", p, c),
  },

  /**
   * 线索资源库
   */
  clueResource_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ums/promote/clueResource/upload", p, c),
  },
  clueResource_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueResource/list", p, c),
  },
  clueResource_listPromotionChannels: {
    /*
     * 推广渠道列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueResource/listPromotionChannels", p, c),
  },
  clueResource_listForContinue: {
    /*
     * 列表-全日制
     */
    get: (p, c) => $.get("/api/ums/promote/clueResource/listForContinue", p, c),
  },
  clueResource_listForAdult: {
    /*
     * 列表-成人教育
     */
    get: (p, c) => $.get("/api/ums/promote/clueResource/listForAdult", p, c),
  },
  clueResource_listChannelAddress: {
    /*
     * 来源网址列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueResource/listChannelAddress", p, c),
  },
  clueResource_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ums/promote/clueResource/export", p, c),
  },
  clueResource_exportForContinue: {
    /*
     * 导出-全日制
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueResource/exportForContinue", p, c),
  },
  clueResource_exportForAdult: {
    /*
     * 导出-成人教育
     */
    get: (p, c) => $.get("/api/ums/promote/clueResource/exportForAdult", p, c),
  },
  clueResource_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/ums/promote/clueResource/downloadMould", p, c),
  },
  clueResource: {
    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/clueResource", p, c),
  },

  /**
   * 线索来源
   */
  clueOrigin: {
    /*
     * 添加
     * clueOrigin  ( query required)
     */
    post: (p, c) => $.post("/api/ums/promote/clueOrigin", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/promote/clueOrigin", p, c),
  },
  clueOrigin_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueOrigin/list", p, c),
  },
  clueOrigin_listDetail: {
    /*
     * 详情列表
     * channel 渠道 (string query required)
     */
    get: (p, c) => $.get("/api/ums/promote/clueOrigin/listDetail", p, c),
  },
  clueOrigin_listChannel: {
    /*
     * 渠道列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueOrigin/listChannel", p, c),
  },

  /**
   * 线索链路追踪
   */
  clueLinkTrace_repairHistory: {
    /*
     * 修复2024年起链路draw ID和首次联系信息
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clueLinkTrace/repairHistory", p, c),
  },
  clueLinkTrace_repairHistoryContact: {
    /*
     * 修复2024年起首次联系信息
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clueLinkTrace/repairHistoryContact", p, c),
  },
  clueLinkTrace_addNotifyConfig: {
    /*
     * 添加分配提醒配置
     * salesAdminId 销售管理员ID (integer query required)
     * directorAdminId 总监管理员ID (integer query required)
     * sort 排序位置（不传则加到末尾） (integer query )
     */
    post: (p, c) =>
      $.post("/api/ums/promote/clueLinkTrace/addNotifyConfig", p, c),
  },
  clueLinkTrace_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueLinkTrace/list", p, c),
  },
  clueLinkTrace_listNotifyConfig: {
    /*
     * 获取分配提醒配置列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueLinkTrace/listNotifyConfig", p, c),
  },
  clueLinkTrace_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ums/promote/clueLinkTrace/export", p, c),
  },
  clueLinkTrace_removeNotifyConfig: {
    /*
     * 删除分配提醒配置
     * id 配置ID (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/ums/promote/clueLinkTrace/removeNotifyConfig", p, c),
  },

  /**
   * 线索领取
   */
  clueDraw_listSecond: {
    /*
     * 重复分配线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueDraw/listSecond", p, c),
  },
  clueDraw_listPromoteConsumeFee: {
    /*
     * 推广消费单列表
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueDraw/listPromoteConsumeFee", p, c),
  },
  clueDraw_listPromoteClue: {
    /*
     * 推广线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueDraw/listPromoteClue", p, c),
  },
  clueDraw_exportSecond: {
    /*
     * 导出重复分配线索列表
     */
    get: (p, c) => $.get("/api/ums/promote/clueDraw/exportSecond", p, c),
  },
  clueDraw_exportPromoteConsumeFee: {
    /*
     * 导出推广消费单
     */
    get: (p, c) =>
      $.get("/api/ums/promote/clueDraw/exportPromoteConsumeFee", p, c),
  },
  clueDraw_exportPromoteClue: {
    /*
     * 导出推广线索
     */
    get: (p, c) => $.get("/api/ums/promote/clueDraw/exportPromoteClue", p, c),
  },
};
